<hdmui-main-application-header
    [sidenavLinks]="sidenavLinks"
    [helpLinks]="helpLinks"
    (mainApplicationHeaderClick)="onMainApplicationHeaderClick($event)"
>
    <div customButtonContainer>
        <hplus-chatbot-widget-icon-button></hplus-chatbot-widget-icon-button>
    </div>
    <div sidenavContent>
        <mat-nav-list>
            <mat-list-item
                (click)="onNotificationsSettingsClick()"
                (keydown.enter)="onNotificationsSettingsClick()"
                (keydown.space)="onNotificationsSettingsClick()"
                [matTooltip]="'NOTIFICATIONS_SETTINGS.TITLE' | translate"
            >
                <mat-icon matListItemIcon svgIcon="hdmui:bell"></mat-icon>
                {{ 'NOTIFICATIONS_SETTINGS.TITLE' | translate }}
            </mat-list-item>
            <mat-list-item
                (click)="onBatchInformationClick()"
                (keydown.enter)="onBatchInformationClick()"
                (keydown.space)="onBatchInformationClick()"
                [matTooltip]="'BATCH_INFORMATION.TITLE' | translate"
            >
                <mat-icon matListItemIcon svgIcon="hdmui:export"></mat-icon>
                {{ 'BATCH_INFORMATION.TITLE' | translate }}
            </mat-list-item>
            @if (isTaskPilotEnabled) {
                <mat-list-item
                    (click)="onStackInformationClick()"
                    (keydown.enter)="onStackInformationClick()"
                    (keydown.space)="onStackInformationClick()"
                    [matTooltip]="'DC.STACK_INFORMATION.TITLE' | translate"
                >
                    <mat-icon matListItemIcon svgIcon="hdmui:palletHigh"></mat-icon>
                    {{ 'DC.STACK_INFORMATION.TITLE' | translate }}
                </mat-list-item>
            }
            <mat-list-item
                (click)="onDieCuttingToolsClick()"
                (keydown.enter)="onDieCuttingToolsClick()"
                (keydown.space)="onDieCuttingToolsClick()"
                [matTooltip]="'DC.SETTINGS.TOOL_USAGE.TITLE' | translate"
            >
                <mat-icon matListItemIcon svgIcon="hdmui:puzzleCutter"></mat-icon>
                {{ 'DC.SETTINGS.TOOL_USAGE.TITLE' | translate }}
            </mat-list-item>
        </mat-nav-list>
    </div>
</hdmui-main-application-header>
